import { SignIn as SignInAmplify } from 'aws-amplify-react';

import LoadingPage from 'components/LogoContainer/LogoContainer';

import Login from './Login';

export class SignIn extends SignInAmplify {
  showComponent(): JSX.Element {
    const { onStateChange } = this.props;
    if (onStateChange) {
      return <Login onStateChange={onStateChange} />;
    }

    return <LoadingPage />;
  }
}
